import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CurrentUserService } from '../../current-user/current-user.service';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirectiveDirective {
  private readonly templateRef = inject(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly currentUserService = inject(CurrentUserService);

  readonly appHasRole = input.required<number[]>();

  private hasView = false;

  constructor() {
    effect(() => {
      const show = this.currentUserService.hasAnyRole(this.appHasRole());
      if (show && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!show && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }
}
